module.exports = __webpack_public_path__ + "static/media/compress-arrows-alt.0ccef47e.svg";